import i18next from 'i18next';

/** Matches API `incident/gate.js` response `code`. */
export const INCIDENT_WORKFLOW_ORCHESTRATED_CODE = 'INCIDENT_WORKFLOW_ORCHESTRATED';

const NS = 'incidentIncidents';

/** API `code` → `incidentIncidents` i18n key (under `errors.*`). */
const INCIDENT_ERROR_CODE_I18N = {
    INCIDENT_WORKFLOW_ORCHESTRATED: 'errors.workflowOrchestrated',
    INCIDENT_PENDING_OPERATION: 'errors.pendingOperation',
    INCIDENT_NOT_FOUND: 'errors.notFound',
    INCIDENT_SUBMIT_INVALID_STATE: 'errors.submitInvalidState',
    INCIDENT_WORKFLOW_TEMPLATE_INVALID: 'errors.workflowTemplateInvalid',
    INCIDENT_SUBMIT_FAILED: 'errors.submitFailed',
    INCIDENT_READ_ONLY: 'errors.readOnly',
    INCIDENT_EDIT_LOCKED: 'errors.editLocked',
};

/**
 * @param {unknown} raw
 * @returns {{ message: string, code?: string, status?: number }}
 */
export function parseIncidentHttpError(raw) {
    if (raw && typeof raw === 'object' && raw.name === 'ApiError' && typeof raw.message === 'string') {
        return {
            message: raw.message,
            code: typeof raw.code === 'string' ? raw.code : undefined,
            status: typeof raw.statusCode === 'number' ? raw.statusCode : undefined,
        };
    }
    const axiosErr = raw?.originalError ?? raw;
    const data = axiosErr?.response?.data ?? raw?.response?.data;
    const status =
        axiosErr?.response?.status ?? raw?.response?.status ?? raw?.status ?? raw?.statusCode;
    const code = typeof data?.code === 'string' ? data.code : undefined;
    const message =
        (typeof data?.error === 'string' && data.error) ||
        (typeof data?.message === 'string' && data.message) ||
        (typeof raw?.message === 'string' ? raw.message : '') ||
        '';
    return { message, code, status };
}

/**
 * Toast copy for incident workflow mutations (i18n-first; avoids raw API strings).
 * @param {unknown} error
 * @param {string} fallback
 */
export function incidentMutationToastMessage(error, fallback) {
    const { code } = parseIncidentHttpError(error);
    if (code && INCIDENT_ERROR_CODE_I18N[code]) {
        return i18next.t(`${NS}:${INCIDENT_ERROR_CODE_I18N[code]}`, { defaultValue: fallback });
    }
    return fallback;
}
